import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-timeout',
    templateUrl: './timeout.component.html',
    styleUrls: ['./timeout.component.css'],
    standalone: false
})
export class TimeoutComponent {
  @Input() message;

  constructor(
    public activeModal: NgbActiveModal
  ) { }
}
